/**
 * "DRIVER HAS ARRIVED" — the backend's `trip.reached_pickup.driver_at`, as a pill.
 *
 * Set the moment the driver app reports the driver inside the pickup radius, independently of
 * whether a notification went out, so it is the reliable status (the toast is the nudge).
 * Renders nothing until then.
 */
export default function DriverArrivedBadge({trip, className = ''}) {
    if (!trip?.reached_pickup?.driver_at) return null
    return (
        <span className={`inline-flex items-center bg-(--accent-green-light) text-(--text-primary) px-4 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap ${className}`}>
            Driver has arrived
        </span>
    )
}
